import { emailRule, emailRuleOptional, germanZipRule, phoneRule, phoneRuleOptional } from "./contactRule";
import { folderPathRule } from "./folderPathRule";
import { ibanRule } from "./ibanRule";
import { bicRule } from "./bicRule";
import { numberHigherRule } from "./numberHigherRule";
import { numberLowerRule } from "./numberLowerRule";
import { requiredRule } from "./requiredRule";
import { maxLengthRule } from "./maxLengthRule";

export enum RulesEnum {
  EMAIL_RULE = "EMAIL_RULE",
  EMAIL_RULE_OPTIONAL = "EMAIL_RULE_OPTIONAL",
  PHONE_RULE = "PHONE_RULE",
  PHONE_RULE_OPTIONAL = "PHONE_RULE_OPTIONAL",
  REQUIRED_RULE = "REQUIRED_RULE",
  IBAN_RULE = "IBAN_RULE",
  BIC_RULE = "BIC_RULE",
  NOT_NEGATIVE_RULE = "NOT_NEGATIVE_RULE",
  MAX_RULE_100 = "MAX_RULE_100",
  GREATER_ZERO_RULE = "GREATER_ZERO_RULE",
  ZIP_GERMANY_RULE = "ZIP_GERMANY_RULE",
  FOLDER_PATH_RULE = "FOLDER_PATH_RULE",
  MAX_LENGTH_RULE_256 = "MAX_LENGTH_RULE_256"
}

type RuleFunction<T = any> = (message?: string) => (value: T) => boolean | string;
export const RulesMap = new Map<RulesEnum, RuleFunction>([
  [RulesEnum.EMAIL_RULE, emailRule],
  [RulesEnum.EMAIL_RULE_OPTIONAL, emailRuleOptional],
  [RulesEnum.PHONE_RULE, phoneRule],
  [RulesEnum.PHONE_RULE_OPTIONAL, phoneRuleOptional],
  [RulesEnum.REQUIRED_RULE, requiredRule],
  [RulesEnum.IBAN_RULE, ibanRule],
  [RulesEnum.BIC_RULE, bicRule],
  [RulesEnum.NOT_NEGATIVE_RULE, () => numberHigherRule(0)],
  [RulesEnum.MAX_RULE_100, () => numberLowerRule(100)],
  [RulesEnum.GREATER_ZERO_RULE, () => numberHigherRule(1)],
  [RulesEnum.ZIP_GERMANY_RULE, germanZipRule],
  [RulesEnum.FOLDER_PATH_RULE, folderPathRule],
  [RulesEnum.MAX_LENGTH_RULE_256, maxLengthRule]
]);

export function rules(...rules: RulesEnum[]) {
  return rules.map((rule) => RulesMap.get(rule)?.());
}
